export default __webpack_public_path__ + "static/media/giraffe-red.c4326d13.svg";